export const siteSettings = {
  name: "Arculus Trade",
  link: "https://arculustrade.net",
  email: "support@arculustrade.net",
  appLink: "https://app.arculustrade.net",
};
